import * as types from '../constants/ActionTypes'
//import config from '../../config/app.js';
import omit from 'lodash/omit'
export default function therapy_areas(state = {}, action) {
	switch (action.type) {

		case types.SET_THERAPY_AREAS:
		return action.payload.reduce((obj, area) => {
			obj[area._id] = area;
			return obj
		}, {});

		case types.UPDATE_THERAPY_AREA:
		case types.INSERT_THERAPY_AREA:
			return {...state, [action.payload._id]: action.payload};

		case types.DELETE_THERAPY_AREA:
			return omit(state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/therapy_areas.js